import { render } from "./NosotrosComp.vue?vue&type=template&id=00b6c64c&scoped=true"
import script from "./NosotrosComp.vue?vue&type=script&lang=js"
export * from "./NosotrosComp.vue?vue&type=script&lang=js"

import "./NosotrosComp.vue?vue&type=style&index=0&id=00b6c64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b6c64c"]])

export default __exports__